
let config = {
    "production": false
};

try{

    let configLocal = require("./config.local.js").default;

    config = Object.assign(config, configLocal);

}catch(e) {

    console.log("Default config applied");
}

export default config;